import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { CoreService } from "./core.service";

type FeatureFlagResponse = {
  status: string;
  result: Array<FeatureFlag>;
};

export type FeatureFlag = {
  NAME: string;
  IS_ENABLED: boolean;
};

type FeatureFlags = {
  cashOut: boolean;
  cashOutDebuggerTable: boolean;
  bookmaker: boolean;
  betEdit: boolean;
  inPlayMarketIdDebugger: boolean;
  openBetsRefId: boolean;
  openBetsBetId: boolean;
  exposureCalculation: boolean;
  openBetsCopy: boolean;
  fancy: boolean;
  apiCallDuration: boolean;
  liveTV: boolean;
  cashOutForMarketsOver3Runners: boolean;
  marketDebuggerWindow: boolean;
};

type _FeatureFlagKeys = keyof FeatureFlags;

export type FeatureFlagKeys = {
  [K in _FeatureFlagKeys]: K;
}[_FeatureFlagKeys];

@Injectable({
  providedIn: "root",
})
export class FeatureFlagService {
  readonly http = inject(HttpClient);
  readonly coreService = inject(CoreService);
  readonly featureFlags$ = new BehaviorSubject<Record<string, boolean>>({});

  constructor() {}

  fetchFeatureFlags(): Observable<FeatureFlagResponse> {
    return this.http.get<FeatureFlagResponse>(`${environment.sURL}${environment.endpoints.featureFlags}`).pipe(
      tap((response: FeatureFlagResponse) => {
        const features = response?.result;
        if (response?.status === "ok" && features?.length > 0) {
          let featureFlags: Record<string, boolean> = {};
          features?.forEach((item: FeatureFlag) => {
            featureFlags[item.NAME] = item?.IS_ENABLED;
          });
          this.featureFlags$.next(featureFlags);
          this.coreService.featureFlags = featureFlags;
        }
      }),
    );
  }

  getFeature(feature: FeatureFlagKeys): boolean {
    return this.featureFlags$.getValue()[feature] ?? false;
  }

  showFeature(key: string, defaultValue: any) {
    return this.featureFlags$.pipe(
      map((flags) => {
        return flags[key] ?? defaultValue;
      }),
    );
  }
}
